import { createFileRoute } from '@tanstack/react-router';
import { TERMS } from '../content/legal-terms.js';
import { LegalDocument, legalHead } from '../components/site/LegalDocument.js';

/**
 * `/terms-of-service`
 *
 * FlexByt Inc.'s Terms of Service as published on the outgoing site, including
 * the Termly section anchors (`#agreement`, `#ip`, …) so existing deep links
 * still land on the same clause.
 */
export const Route = createFileRoute('/terms-of-service')({
  head: () => legalHead(TERMS),
  component: () => <LegalDocument doc={TERMS} />,
});
